/** Generate a stable DOM id for a slash menu item at a given index */
export function slashMenuItemId(index: number): string {
  return `slash-menu-item-${index}`;
}
